import { inject } from './inject';
import { PaymentCardNumber as BasePaymentCardNumber } from './PaymentCardNumber';

export const PaymentCardNumber = inject(BasePaymentCardNumber);
